export const DFX_SYMBOL = {
  XAU_USD: 'xau-usd',
  XAG_USD: 'xag-usd',
  XAU_EUR: 'xau-eur',
  XAU_GBP: 'xau-gbp',
  XAU_CHF: 'xau-chf',
  XAG_EUR: 'xag-eur',
  XAG_GBP: 'xag-gbp',
  XPT_USD: 'xpt-usd',
  XPD_USD: 'xpd-usd',
  HG1: 'hg1',
  WTI_CRUDE_OIL: 'cl1',
  UK_OIL: 'co1',
  NATURAL_GAS: 'ng1',
  GASOLINE: 'xb1',
  HEATING_OIL: 'ho1',
  COPPER: 'hg1',
  CORN: 'c1',
  SOYBEANS: 's1',
  WHEAT: 'w1',
  SP_500: 'spx',
  NASDAQ_100: 'ndx',
  DOW_JONES: 'indu',
  NIKKEI_225: 'nky',
  HANG_SENG: 'hsi',
  FTSE_100: 'ukx',
  EURO_STOXX_50: 'sx5e',
  DAX: 'dax',
  CAC_40: 'cac',
  AEX: 'aex',
  AMZN: 'amzn',
  AXP: 'axp',
  AAPL: 'aapl',
  BA: 'ba',
  CAT: 'cat',
  CVX: 'cvx',
  CSCO: 'csco',
  KO: 'ko',
  DIS: 'dis',
  DOW: 'dow',
  XOM: 'xom',
  GS: 'gs',
  HD: 'hd',
  IBM: 'ibm',
  INTC: 'intc',
  JNJ: 'jnj',
  JPM: 'jpm',
  MCD: 'mcd',
  MMM: 'mmm',
  MRK: 'mrk',
  MSFT: 'msft',
  NKE: 'nke',
  PFE: 'pfe',
  PG: 'pg',
  TRV: 'trv',
  RTX: 'rtx',
  UNH: 'unh',
  VZ: 'vz',
  V: 'v',
  WMT: 'wmt',
  WBA: 'wba',
  GOOG: 'goog',
  BABA: 'baba',
  GE: 'ge',
  T: 't',

  BRKB: 'brk-b',
  MA: 'ma',
  BAC: 'bac',
  NFLX: 'nflx',
  PYPL: 'pypl',
  SBUX: 'sbux',
  DPZ: 'dpz',
  C: 'c',
  RY: 'ry',
  SHOP: 'shop',
  BP: 'bp',
  TWTR: 'twtr',
  GOLD: 'gold',
  BITCOIN: 'btc-usd',
  ETHEREUM: 'eth-usd',
  XRP: 'xrp-usd',
  LITECOIN: 'ltc-usd',
  EOS: 'eos-usd',
  BITCOIN_CASH: 'bch-usd',
  BITCOIN_SV: 'bsv-usd',
  TETHER: 'usdt-usd',
  BINANCE_COIN: 'bnb-usd',
  CARDANO: 'ada-usd',
  TEZOS: 'xtz-usd',
  STELLAR: 'xlm-usd',
  MORENO: 'xmr-usd',
  NEO: 'neo-usd',
  DASH: 'dash-usd',
  TRON: 'trx-usd',
  ETHEREUM_CLASSIC: 'etc-usd',
  EUR_USD: 'eur-usd',
  USD_JPY: 'usd-jpy',
  GBP_USD: 'gbp-usd',
  USD_CHF: 'usd-chf',
  USD_CAD: 'usd-cad',
  AUD_USD: 'aud-usd',
  NZD_USD: 'nzd-usd',
  EUR_JPY: 'eur-jpy',
  EUR_GBP: 'eur-gbp',
  EUR_CHF: 'eur-chf',
  AUD_JPY: 'aud-jpy',
  GBP_JPY: 'gbp-jpy',
  CHF_JPY: 'chf-jpy',
  EUR_CAD: 'eur-cad',
  AUD_CAD: 'aud-cad',
  CAD_JPY: 'cad-jpy',
  NZD_JPY: 'nzd-jpy',
  AUD_NZD: 'aud-nzd',
  GBP_AUD: 'gbp-aud',
  EUR_AUD: 'eur-aud',
  GBP_CHF: 'gbp-chf',
  EUR_NZD: 'eur-nzd',
  AUD_CHF: 'aud-chf',
  USD_CNY: 'usd-cny',
  USD_NOK: 'usd-nok',
  EUR_NOK: 'eur-nok',
  USD_SEK: 'usd-sek',
  EUR_SEK: 'eur-sek',
  USD_RUB: 'usd-rub',
  EUR_RUB: 'eur-rub',
  USD_HKD: 'usd-hkd',
  USD_MXN: 'usd-mxn',
  USD_SGD: 'usd-sgd',
  USD_TRY: 'usd-try',
  USD_BRL: 'usd-brl',
  USD_RON: 'usd-ron',
  USD_CNH: 'usd-cnh',
  USD_DKK: 'usd-dkk',
  GBP_NZD: 'gbp-nzd',
  GBP_CAD: 'gbp-cad'
}

export const DFX_SYMBOL_VALUES_LOWERCASED = Object.values(DFX_SYMBOL).map(v =>
  v.toLowerCase()
)
export const TV_SYMBOL_QUERY_PARAM = 'tvwidgetsymbol'

export const TV_SYMBOL = {
  BITSTAMP_BTC_USD: 'BITSTAMP:BTCUSD',
  BITSTAMP_ETH_USD: 'BITSTAMP:ETHUSD',
  BINANCE_BNB_USD: 'BINANCE:BNBUSD',
  BINANCE_DOGE_USD: 'BINANCE:DOGEUSD',
  BINANCE_MATIC_USD: 'BINANCE:MATICUSD',
  COINBASE_ADA_USD: 'COINBASE:ADAUSD',
  BINANCE_DOT_USD: 'BINANCE:DOTUSD',
  COINBASE_LTC_USD: 'COINBASE:LTCUSD',
  BITSTAMP_DAI_USD: 'BITSTAMP:DAIUSD',
  BINANCE_FTM_USD: 'BINANCE:FTMUSD',
  COINBASE_SHIB_USD: 'COINBASE:SHIBUSD',
  COINBASE_APE_USD: 'COINBASE:APEUSD',
  BINANCE_SOL_USD: 'BINANCE:SOLUSD',
  BINANCE_TRX_USD: 'BINANCE:TRXUSD',
  BINANCE_AVAX_USD: 'BINANCE:AVAXUSD',
  COINBASE_BCH_USD: 'COINBASE:BCHUSD',
  BINANCE_NEAR_USD: 'BINANCE:NEARUSD',
  COINBASE_ATOM_USD: 'COINBASE:ATOMUSD',
  BINANCE_SAND_USD: 'BINANCE:SANDUSD',
  BINANCE_WAVES_USD: 'BINANCE:WAVESUSD',
  NASDAQ_TSLA: 'NASDAQ:TSLA',
  NASDAQ_AAPL: 'NASDAQ:AAPL',
  NASDAQ_AMZN: 'NASDAQ:AMZN',
  NASDAQ_MSFT: 'NASDAQ:MSFT',
  NASDAQ_META: 'NASDAQ:META',
  NASDAQ_NFLX: 'NASDAQ:NFLX',
  NASDAQ_NVDA: 'NASDAQ:NVDA',
  NASDAQ_AMD: 'NASDAQ:AMD',
  NASDAQ_INTC: 'NASDAQ:INTC',
  NYSE_T: 'NYSE:T',
  NYSE_BA: 'NYSE:BA',
  NYSE_BAC: 'NYSE:BAC',
  NYSE_KO: 'NYSE:KO',
  NASDAQ_SBUX: 'NASDAQ:SBUX',
  NASDAQ_AAL: 'NASDAQ:AAL',
  NYSE_DAL: 'NYSE:DAL',
  NYSE_CCL: 'NYSE:CCL',
  NYSE_XOM: 'NYSE:XOM',
  NASDAQ_PYPL: 'NASDAQ:PYPL',
  NASDAQ_ENPH: 'NASDAQ:ENPH',
  NYSE_SQ: 'NYSE:SQ',
  NYSE_WMT: 'NYSE:WMT',
  NASDAQ_COST: 'NASDAQ:COST',
  NYSE_DIS: 'NYSE:DIS',
  NYSE_SNAP: 'NYSE:SNAP',
  NYSE_BABA: 'NYSE:BABA',
  NASDAQ_COIN: 'NASDAQ:COIN',
  NYSE_SHOP: 'NYSE:SHOP',
  NYSE_U: 'NYSE:U',
  NYSE_GM: 'NYSE:GM',
  NASDAQ_FORD: 'NASDAQ:FORD',
  NYSE_NIO: 'NYSE:NIO',
  NASDAQ_LCID: 'NASDAQ:LCID',
  NASDAQ_TLRY: 'NASDAQ:TLRY',
  NASDAQ_CGC: 'NASDAQ:CGC',
  NASDAQ_ACB: 'NASDAQ:ACB',
  NYSE_NKE: 'NYSE:NKE',
  NYSE_HD: 'NYSE:HD',
  NYSE_TGT: 'NYSE:TGT',
  NASDAQ_ROKU: 'NASDAQ:ROKU',
  NYSE_JNJ: 'NYSE:JNJ',
  NYSE_MCD: 'NYSE:MCD',
  NASDAQ_ZM: 'NASDAQ:ZM',
  NYSE_UBER: 'NYSE:UBER',
  NASDAQ_DKNG: 'NASDAQ:DKNG',
  NASDAQ_FSLR: 'NASDAQ:FSLR',
  NASDAQ_ETSY: 'NASDAQ:ETSY',
  NYSE_NET: 'NYSE:NET',
  NYSE_AMC: 'NYSE:AMC',
  NYSE_GME: 'NYSE:GME',
  FX_EUR_USD: 'FX:EURUSD',
  FX_USD_JPY: 'FX:USDJPY',
  FX_USD_CAD: 'FX:USDCAD',
  FX_GBP_USD: 'FX:GBPUSD',
  FX_EUR_CHF: 'FX:EURCHF',
  FX_USD_HKD: 'FX:USDHKD',
  FX_AUD_JPY: 'FX:AUDJPY',
  FX_USD_CHF: 'FX:USDCHF',
  FX_AUD_USD: 'FX:AUDUSD',
  FX_NZD_USD: 'FX:NZDUSD',
  FOREXCOM_GBP_MXN: 'FOREXCOM:GBPMXN',
  OANDA_SGD_JPY: 'OANDA:SGDJPY',
  FX_EUR_JPY: 'FX:EURJPY',
  FX_EUR_GBP: 'FX:EURGBP',
  FX_EUR_AUD: 'FX:EURAUD',
  FX_GBP_JPY: 'FX:GBPJPY',
  FX_CHF_JPY: 'FX:CHFJPY',
  OANDA_NZD_JPY: 'OANDA:NZDJPY',
  FX_GBP_CAD: 'FX:GBPCAD',
  FOREXCOM_CHF_HUF: 'FOREXCOM:CHFHUF',
  SAXO_GBP_CZK: 'SAXO:GBPCZK',
  FX_EUR_TRY: 'FX:EURTRY',
  SAXO_JPY_NOK: 'SAXO:JPYNOK',
  OANDA_NZD_SGD: 'OANDA:NZDSGD',
  FX_IDC_USD_CNY: 'FX_IDC:USDCNY',
  FX_IDC_USD_INR: 'FX_IDC:USDINR',
  FOREXCOM_USD_ILS: 'FOREXCOM:USDILS',
  FX_USD_TRY: 'FX:USDTRY',
  FX_IDC_USD_RUB: 'FX_IDC:USDRUB',
  FX_IDC_EUR_RUB: 'FX_IDC:EURRUB',
  PEPPERSTONE_VIX: 'PEPPERSTONE:VIX',
  INDEX_SX5E: 'INDEX:SX5E',
  JSE_J200: 'JSE:J200',
  OANDA_XAUUSD: 'OANDA:XAUUSD',
  OANDA_WTICOUSD: 'OANDA:WTICOUSD',
  OANDA_XCUUSD: 'OANDA:XCUUSD',
  OANDA_NATGASUSD: 'OANDA:NATGASUSD',
  BINANCE_ETHUSDT: 'BINANCE:ETHUSDT',
  BINANCE_BTCUSD: 'BINANCE:BTCUSDT',
  NASDAQ_NDX: 'NASDAQ:NDX',
  NASDAQ_IXIC: 'NASDAQ:IXIC',
  CAPITALCOM_RTY: 'CAPITALCOM:RTY',
  XETR_DAX: 'XETR:DAX',
  VANTAGE_CHINA50: 'VANTAGE:CHINA50',
  PEPPERSTONE_HK50: 'PEPPERSTONE:HK50',
  CURRENCYCOM_US30: 'CURRENCYCOM:US30',
  CURRENCYCOM_US100: 'CURRENCYCOM:US100',
  CURRENCYCOM_US500: 'CURRENCYCOM:US500',
  GLOBALPRIME_NAS100: 'GLOBALPRIME:NAS100',
  CRYPTOCAP_TOTAL: 'CRYPTOCAP:TOTAL',
  CAPITALCOM_DXY: 'CAPITALCOM:DXY',
  HSI_HSI: 'HSI:HSI',
  NASDAQ_NQEM: 'NASDAQ:NQEM',
  USI_PC: 'USI:PC',
  CME_MINI_ES1: 'CME_MINI:ES1!',
  CME_MINI_NQ1: 'CME_MINI:NQ1!',
  CME_MINI_RTY1: 'CME_MINI:RTY1!',
  CBOT_MINI_YM1: 'CBOT_MINI:YM1!',
  NYMEX_NG1: 'NYMEX:NG1!',
  NYMEX_CL1: 'NYMEX:CL1!',
  NYMEX_RB1: 'NYMEX:RB1!',
  COMEX_GC1: 'COMEX:GC1!',
  COMEX_SI1: 'COMEX:SI1!',
  COMEX_HG1: 'COMEX:HG1!',
  NYMEX_PL1: 'NYMEX:PL1!',
  COMEX_ALI1: 'COMEX:ALI1!',
  COMEX_LTH1: 'COMEX:LTH1!',
  CBOT_AW1: 'CBOT:AW1!',
  CBOT_ZS1: 'CBOT:ZS1!',
  CBOT_ZC1: 'CBOT:ZC1!',
  CBOT_ZW1: 'CBOT:ZW1!',
  CME_LE1: 'CME:LE1!',
  CBOT_KE1: 'CBOT:KE1!',
  PEPPERSTONE_SUGAR: 'PEPPERSTONE:SUGAR',
  NYMEX_TT1: 'NYMEX:TT1!',
  CBOT_ZO1: 'CBOT:ZO1!',
  CME_HE1: 'CME:HE1!',
  CBOT_ZB1: 'CBOT:ZB1!',
  CBOT_ZT1: 'CBOT:ZT1!',
  CBOT_ZF1: 'CBOT:ZF1!',
  CME_6E1: 'CME:6E1!',
  CME_6B1: 'CME:6B1!',
  CME_6J1: 'CME:6J1!',
  CME_BTC1: 'CME:BTC1!',
  CME_ETH1: 'CME:ETH1!',
  AMEX_VIXY: 'AMEX:VIXY',
  FRED_FEDFUNDS: 'FRED:FEDFUNDS',
  ECONOMICS_USIRYY: 'ECONOMICS:USIRYY',
  ECONOMICS_USINTR: 'ECONOMICS:USINTR',
  FRED_UNRATE: 'FRED:UNRATE',
  FRED_T10Y2Y: 'FRED:T10Y2Y',
  FRED_T10YIE: 'FRED:T10YIE',
  ECONOMICS_USCPMI: 'ECONOMICS:USCPMI',
  FRED_MORTGAGE30US: 'FRED:MORTGAGE30US',
  ECONOMICS_USCCPI: 'ECONOMICS:USCCPI',
  FRED_WALCL: 'FRED:WALCL',
  ECONOMICS_USM2: 'ECONOMICS:USM2',
  ECONOMICS_USCBBS: 'ECONOMICS:USCBBS',
  FRED_EFFR: 'FRED:EFFR',
  ECONOMICS_USNMPMI: 'ECONOMICS:USNMPMI',
  ECONOMICS_USNFP: 'ECONOMICS:USNFP',
  ECONOMICS_USCPI: 'ECONOMICS:USCPI',
  FRED_NFCI: 'FRED:NFCI',
  ECONOMICS_USUR: 'ECONOMICS:USUR',
  ECONOMICS_USGDPQQ: 'ECONOMICS:USGDPQQ',
  FRED_SOFR: 'FRED:SOFR',
  FRED_RRPONTTLD: 'FRED:RRPONTTLD',
  ECONOMICS_USGDP: 'ECONOMICS:USGDP',
  ECONOMICS_CAGDP: 'ECONOMICS:CAGDP',
  ECONOMICS_EUGDP: 'ECONOMICS:EUGDP',
  ECONOMICS_DEGDP: 'ECONOMICS:DEGDP',
  ECONOMICS_GBGDP: 'ECONOMICS:GBGDP',
  ECONOMICS_CNGDP: 'ECONOMICS:CNGDP',
  ECONOMICS_BRGDP: 'ECONOMICS:BRGDP',
  ECONOMICS_INGDP: 'ECONOMICS:INGDP',
  ECONOMICS_JPGDP: 'ECONOMICS:JPGDP',
  FOREXCOM_SPX500: 'FOREXCOM:SPX500',
  FOREXCOM_US30: 'FOREXCOM:US30',
  FOREXCOM_US2000: 'FOREXCOM:US2000',
  CAPITALCOM_NFTY: 'CAPITALCOM:NFTY',
  CME_LBR1: 'CME:LBR1!',
  MOEX_ED1: 'MOEX:ED1!'
}

export const TV_SYMBOL_NAME_BY_TV_SYMBOL = {
  [TV_SYMBOL.FX_EUR_USD]: 'Euro / US dollar',
  [TV_SYMBOL.FX_USD_JPY]: 'US dollar / Japanese yen',
  [TV_SYMBOL.FX_USD_CAD]: 'US dollar / Canadian dollar',
  [TV_SYMBOL.FX_GBP_USD]: 'British pound / US dollar',
  [TV_SYMBOL.FX_USD_CHF]: 'US dollar / Swiss franc',
  [TV_SYMBOL.FX_AUD_USD]: 'Australian dollar / US dollar',
  [TV_SYMBOL.FX_NZD_USD]: 'New Zealand dollar / US dollar',
  [TV_SYMBOL.FOREXCOM_GBP_MXN]: 'British pound / Mexican peso',
  [TV_SYMBOL.OANDA_SGD_JPY]: 'Singapore dollar / Japanese yen',
  [TV_SYMBOL.FX_EUR_JPY]: 'Euro / Japanese yen',
  [TV_SYMBOL.FX_EUR_GBP]: 'Euro / British pound',
  [TV_SYMBOL.FX_EUR_AUD]: 'Euro / Australian dollar',
  [TV_SYMBOL.FX_GBP_JPY]: 'British pound / Japanese yen',
  [TV_SYMBOL.FX_CHF_JPY]: 'Swiss franc / Japanese yen',
  [TV_SYMBOL.OANDA_NZD_JPY]: 'New Zealand dollar / Japanese yen',
  [TV_SYMBOL.FX_GBP_CAD]: 'British pound / Canadian dollar',
  [TV_SYMBOL.FOREXCOM_CHF_HUF]: 'Swiss franc / Hungarian forint',
  [TV_SYMBOL.SAXO_GBP_CZK]: 'British pound / Czech koruna',
  [TV_SYMBOL.FX_EUR_TRY]: 'Euro / Turkish lira',
  [TV_SYMBOL.SAXO_JPY_NOK]: 'Japanese yen / Norwegian krone',
  [TV_SYMBOL.OANDA_NZD_SGD]: 'New Zealand dollar / Singapore dollar',
  [TV_SYMBOL.FX_IDC_USD_CNY]: 'US dollar / Chinese yuan',
  [TV_SYMBOL.FX_IDC_USD_INR]: 'US dollar / Indian rupee',
  [TV_SYMBOL.FOREXCOM_USD_ILS]: 'US dollar / Israeli shekel',
  [TV_SYMBOL.FX_USD_TRY]: 'US dollar / Turkish lira',
  [TV_SYMBOL.FX_IDC_USD_RUB]: 'US dollar / Russian rouble',
  [TV_SYMBOL.FX_IDC_EUR_RUB]: 'Euro / Russian rouble',
  [TV_SYMBOL.CME_MINI_ES1]: 'E-Mini S&P 500 Futures',
  [TV_SYMBOL.CME_MINI_NQ1]: 'E-Mini Nasdaq-100 Futures',
  [TV_SYMBOL.CME_MINI_RTY1]: 'E-Mini Russell 2000 Index Futures',
  [TV_SYMBOL.CBOT_MINI_YM1]: 'E-Mini Dow ($5) Futures',
  [TV_SYMBOL.NYMEX_NG1]: 'Henry Hub Natural Gas Futures',
  [TV_SYMBOL.NYMEX_CL1]: 'Crude Oil Futures',
  [TV_SYMBOL.NYMEX_RB1]: 'RBOB Gasoline Futures',
  [TV_SYMBOL.COMEX_GC1]: 'Gold Futures',
  [TV_SYMBOL.COMEX_SI1]: 'Silver Futures',
  [TV_SYMBOL.COMEX_HG1]: 'Copper Futures',
  [TV_SYMBOL.NYMEX_PL1]: 'Platinum Futures',
  [TV_SYMBOL.COMEX_ALI1]: 'Aluminium Futures',
  [TV_SYMBOL.COMEX_LTH1]: 'Lithium Futures',
  [TV_SYMBOL.CBOT_AW1]: 'Bloomberg Commodity Index Futures',
  [TV_SYMBOL.CBOT_ZS1]: 'Soybean Futures',
  [TV_SYMBOL.CBOT_ZC1]: 'Corn Futures',
  [TV_SYMBOL.CBOT_ZW1]: 'Wheat Futures',
  [TV_SYMBOL.CME_LE1]: 'Live Cattle Futures',
  [TV_SYMBOL.CBOT_KE1]: 'Coffee Futures',
  [TV_SYMBOL.PEPPERSTONE_SUGAR]: 'Sugar No. 11 Futures',
  [TV_SYMBOL.CME_LBR1]: 'Random Length Lumber Futures',
  [TV_SYMBOL.NYMEX_TT1]: 'Cotton No. 2 Futures',
  [TV_SYMBOL.CBOT_ZO1]: 'Oats Futures',
  [TV_SYMBOL.CME_HE1]: 'Lean Hog Futures',
  [TV_SYMBOL.CBOT_ZB1]: 'U.S. Treasury Bond Futures',
  [TV_SYMBOL.CBOT_ZT1]: '2-Year T-Note Futures',
  [TV_SYMBOL.CBOT_ZF1]: '5-Year T-Note Futures',
  [TV_SYMBOL.CME_6E1]: 'Euro FX Futures',
  [TV_SYMBOL.CME_6B1]: 'British Pound Futures',
  [TV_SYMBOL.CME_6J1]: 'Japanese Yen Futures',
  [TV_SYMBOL.CME_BTC1]: 'Bitcoin Futures',
  [TV_SYMBOL.CME_ETH1]: 'Ethereum Futures',
  [TV_SYMBOL.AMEX_VIXY]: 'VIX Futures',
  [TV_SYMBOL.BITSTAMP_BTC_USD]: 'Bitcoin / US dollar',
  [TV_SYMBOL.BITSTAMP_ETH_USD]: 'Ethereum / US dollar',
  [TV_SYMBOL.BINANCE_BNB_USD]: 'Binance coin / US dollar',
  [TV_SYMBOL.BINANCE_DOGE_USD]: 'Dogecoin / US dollar',
  [TV_SYMBOL.BINANCE_MATIC_USD]: 'Matic / US dollar',
  [TV_SYMBOL.COINBASE_ADA_USD]: 'Cardano / US dollar',
  [TV_SYMBOL.BINANCE_DOT_USD]: 'Dot / US dollar',
  [TV_SYMBOL.COINBASE_LTC_USD]: 'Litecoin / US dollar',
  [TV_SYMBOL.BITSTAMP_DAI_USD]: 'DAI / US dollar',
  [TV_SYMBOL.BINANCE_FTM_USD]: 'Fantom / US dollar',
  [TV_SYMBOL.COINBASE_SHIB_USD]: 'Shiba / US dollar',
  [TV_SYMBOL.COINBASE_APE_USD]: 'Ape / US dollar',
  [TV_SYMBOL.BINANCE_SOL_USD]: 'Solana / US dollar',
  [TV_SYMBOL.BINANCE_TRX_USD]: 'TRX / US dollar',
  [TV_SYMBOL.BINANCE_AVAX_USD]: 'Avax / US dollar',
  [TV_SYMBOL.COINBASE_BCH_USD]: 'Bitcoin cash / US dollar',
  [TV_SYMBOL.BINANCE_NEAR_USD]: 'Near / US dollar',
  [TV_SYMBOL.COINBASE_ATOM_USD]: 'Cosmos / US dollar',
  [TV_SYMBOL.BINANCE_SAND_USD]: 'The Sandbox / US dollar',
  [TV_SYMBOL.BINANCE_WAVES_USD]: 'Waves / US dollar',
  [TV_SYMBOL.NASDAQ_TSLA]: 'Tesla',
  [TV_SYMBOL.NASDAQ_AAPL]: 'Apple',
  [TV_SYMBOL.NASDAQ_AMZN]: 'Amazon',
  [TV_SYMBOL.NASDAQ_MSFT]: 'Microsoft',
  [TV_SYMBOL.NASDAQ_META]: 'Meta',
  [TV_SYMBOL.NASDAQ_NFLX]: 'Netflix',
  [TV_SYMBOL.NASDAQ_NVDA]: 'NVidia',
  [TV_SYMBOL.NASDAQ_AMD]: 'Advanced Micro Devices',
  [TV_SYMBOL.NASDAQ_INTC]: 'Intel',
  [TV_SYMBOL.NYSE_T]: 'AT&T',
  [TV_SYMBOL.NYSE_BA]: 'Boeing',
  [TV_SYMBOL.NYSE_BAC]: 'Bank of America',
  [TV_SYMBOL.NYSE_KO]: 'Coca-Cola',
  [TV_SYMBOL.NASDAQ_SBUX]: 'Starbucks',
  [TV_SYMBOL.NASDAQ_AAL]: 'American Airlines',
  [TV_SYMBOL.NYSE_DAL]: 'Delta Airlines',
  [TV_SYMBOL.NYSE_CCL]: 'Carnival',
  [TV_SYMBOL.NYSE_XOM]: 'Exxon Mobile',
  [TV_SYMBOL.NASDAQ_PYPL]: 'PayPal',
  [TV_SYMBOL.NASDAQ_ENPH]: 'Enphase Energy',
  [TV_SYMBOL.NYSE_SQ]: 'Square',
  [TV_SYMBOL.NYSE_WMT]: 'Walmart',
  [TV_SYMBOL.NASDAQ_COST]: 'Costco',
  [TV_SYMBOL.NYSE_DIS]: 'Disney',
  [TV_SYMBOL.NYSE_SNAP]: 'Snap',
  [TV_SYMBOL.NYSE_BABA]: 'Alibaba',
  [TV_SYMBOL.NASDAQ_COIN]: 'Coinbase',
  [TV_SYMBOL.NYSE_SHOP]: 'Shopify',
  [TV_SYMBOL.NYSE_U]: 'Unity',
  [TV_SYMBOL.NYSE_GM]: 'General Motors',
  [TV_SYMBOL.NASDAQ_FORD]: 'FORD',
  [TV_SYMBOL.NYSE_NIO]: 'NIO',
  [TV_SYMBOL.NASDAQ_LCID]: 'Lucid Group',
  [TV_SYMBOL.NASDAQ_TLRY]: 'Tilray',
  [TV_SYMBOL.NASDAQ_CGC]: 'Canopy Growth',
  [TV_SYMBOL.NASDAQ_ACB]: 'Aurora Cannabis',
  [TV_SYMBOL.NYSE_NKE]: 'Nike',
  [TV_SYMBOL.NYSE_HD]: 'Home Depot',
  [TV_SYMBOL.NYSE_TGT]: 'Target',
  [TV_SYMBOL.NASDAQ_ROKU]: 'Roku',
  [TV_SYMBOL.NYSE_JNJ]: 'Johnson & Johnson',
  [TV_SYMBOL.NYSE_MCD]: "McDonald's",
  [TV_SYMBOL.NASDAQ_ZM]: 'Zoom Video',
  [TV_SYMBOL.NYSE_UBER]: 'Uber',
  [TV_SYMBOL.NASDAQ_DKNG]: 'Draftkings',
  [TV_SYMBOL.NASDAQ_FSLR]: 'First Solar',
  [TV_SYMBOL.NASDAQ_ETSY]: 'Etsy',
  [TV_SYMBOL.NYSE_NET]: 'Cloudflare',
  [TV_SYMBOL.NYSE_AMC]: 'AMC Entertainment Holdings',
  [TV_SYMBOL.NYSE_GME]: 'GameStop',
  [TV_SYMBOL.FOREXCOM_SPX500]: 'S&P 500 Index',
  [TV_SYMBOL.PEPPERSTONE_VIX]: 'US Volatility Index',
  [TV_SYMBOL.INDEX_SX5E]: 'Euro Stoxx 50 Index',
  [TV_SYMBOL.JSE_J200]: 'South Africa Top 40 Index',
  [TV_SYMBOL.OANDA_XAUUSD]: 'Live Gold Price Chart - XAUUSD',
  [TV_SYMBOL.OANDA_WTICOUSD]: 'WTI Crude Oil Price Chart',
  [TV_SYMBOL.OANDA_XCUUSD]: 'Live Copper Price Chart - XCUUSD',
  [TV_SYMBOL.OANDA_NATGASUSD]: 'Natural Gas Price Chart',
  [TV_SYMBOL.BINANCE_ETHUSDT]: 'Ethereum Price Chart - ETHUSDT',
  [TV_SYMBOL.BINANCE_BTCUSD]: 'Bitcoin Price Chart - BTCUSD',
  [TV_SYMBOL.NASDAQ_NDX]: 'NASDAQ 100',
  [TV_SYMBOL.FOREXCOM_US30]: 'Wall Street',
  [TV_SYMBOL.CAPITALCOM_RTY]: 'US Russel 2000',
  [TV_SYMBOL.FOREXCOM_US2000]: 'Russel 2000 Cash',
  [TV_SYMBOL.NASDAQ_IXIC]: 'Nasdaq Composite Index',
  [TV_SYMBOL.XETR_DAX]: 'DAX Index',
  [TV_SYMBOL.CAPITALCOM_NFTY]: 'NSE:NIFTY',
  [TV_SYMBOL.VANTAGE_CHINA50]: 'China A50 Index Cash CFD (USD)',
  [TV_SYMBOL.PEPPERSTONE_HK50]: 'Hong Kong 50 Index',
  [TV_SYMBOL.CURRENCYCOM_US30]: 'Dow Jones Industrial Average Index',
  [TV_SYMBOL.CURRENCYCOM_US100]: 'US 100',
  [TV_SYMBOL.CURRENCYCOM_US500]: 'US 500',
  [TV_SYMBOL.GLOBALPRIME_NAS100]: 'US 100 Cash CFD',
  [TV_SYMBOL.CRYPTOCAP_TOTAL]: 'Crypto Total Market Cap, $',
  [TV_SYMBOL.CAPITALCOM_DXY]: 'US Dollar Index',
  [TV_SYMBOL.HSI_HSI]: 'Hang Seng',
  [TV_SYMBOL.NASDAQ_NQEM]: 'The Nasdaq Emerging Markets Indexed',
  [TV_SYMBOL.USI_PC]: 'Putt / Call Ratio',
  [TV_SYMBOL.FRED_FEDFUNDS]: 'Effective Federal Funds Rate - Federal Reserve',
  [TV_SYMBOL.ECONOMICS_USIRYY]: 'United States Inflation Rate, YoY',
  [TV_SYMBOL.ECONOMICS_USINTR]: 'United States Interest Rate',
  [TV_SYMBOL.FRED_UNRATE]: 'Civilian Unemployment Rate',
  [TV_SYMBOL.FRED_T10Y2Y]:
    '10-Year Treasury Constant Maturity Minus 2-Year Treasury Constant Maturity',
  [TV_SYMBOL.FRED_T10YIE]: '10-Year Breakeven Inflation Rate',
  [TV_SYMBOL.ECONOMICS_USCPMI]: 'United States Chicago PMI',
  [TV_SYMBOL.FRED_MORTGAGE30US]:
    '30-Year Fixed Rate Mortgage Average in the United States',
  [TV_SYMBOL.ECONOMICS_USCCPI]: 'United States Core CPI, YoY',
  [TV_SYMBOL.FRED_WALCL]:
    'Assets: Total Assets: Total Assets (Less Eliminations from Consolidation): Wednesday Level',
  [TV_SYMBOL.ECONOMICS_USM2]: 'United States Money Supply M2',
  [TV_SYMBOL.ECONOMICS_USCBBS]: 'United States Central Bank Balance Sheet',
  [TV_SYMBOL.FRED_EFFR]:
    'Effective Federal Funds Rate - Federal Reserve Bank of New York',
  [TV_SYMBOL.ECONOMICS_USNMPMI]: 'United States Non-Manufacturing PMI',
  [TV_SYMBOL.ECONOMICS_USNFP]: 'United States Nonfarm Payrolls',
  [TV_SYMBOL.ECONOMICS_USCPI]: 'United States Consumer Price Index',
  [TV_SYMBOL.FRED_NFCI]: 'Chicago Fed National Financial Conditions Index',
  [TV_SYMBOL.ECONOMICS_USUR]: 'United States Unemployment Rate',
  [TV_SYMBOL.ECONOMICS_USGDPQQ]: 'United States GDP Growth Rate',
  [TV_SYMBOL.FRED_SOFR]: 'Secured Overnight Financing Rate',
  [TV_SYMBOL.FRED_RRPONTTLD]:
    'Overnight Reverse Repurchase Agreements: Total Securities Sold by the Federal Reserve in the Temporary Open Market Operations',
  [TV_SYMBOL.ECONOMICS_USGDP]: 'United States GDP',
  [TV_SYMBOL.ECONOMICS_CAGDP]: 'Canada GDP',
  [TV_SYMBOL.ECONOMICS_EUGDP]: 'Euro Area GDP',
  [TV_SYMBOL.ECONOMICS_DEGDP]: 'Germany GDP',
  [TV_SYMBOL.ECONOMICS_GBGDP]: 'United Kingdom GDP',
  [TV_SYMBOL.ECONOMICS_CNGDP]: 'China GDP',
  [TV_SYMBOL.ECONOMICS_BRGDP]: 'Brazil GDP',
  [TV_SYMBOL.ECONOMICS_INGDP]: 'India GDP',
  [TV_SYMBOL.ECONOMICS_JPGDP]: 'Japan GDP',
  [TV_SYMBOL.FX_EUR_CHF]: 'Euro / Swiss Franc',
  [TV_SYMBOL.FX_USD_HKD]: 'U.S. Dollar / Hong Kong Dollar',
  [TV_SYMBOL.FX_AUD_JPY]: 'Australian Dollar / Japanese Yen'
}

export const TV_SYMBOL_VALUES_LOWERCASED = Object.values(TV_SYMBOL).map(v =>
  v.toLowerCase()
)

export const ALTERNATIVE_TV_SYMBOL = {
  FX_BTC_USD: 'FX:BTCUSD',
  KRAKEN_XBT_USD: 'KRAKEN:XBTUSD',
  KRAKEN_ETH_USD: 'KRAKEN:ETHUSD',
  KRAKEN_LTC_USD: 'KRAKEN:LTCUSD',
  KRAKEN_BCH_USD: 'KRAKEN:BCHUSD',
  KRAKEN_XRP_USD: 'KRAKEN:XRPUSD',
  KRAKEN_EOS_USD: 'KRAKEN:EOSUSD',
  FX_AMZN: 'FX:AMZN',
  EURUSD: 'EURUSD',
  GBPUSD: 'GBPUSD',
  FX_IDC_CHF_JPY: 'FX_IDC:CHFJPY',
  FX_IDC_NZD_JPY: 'FX_IDC:NZDJPY',
  SPX: 'SPX',
  SPX_500: 'SPX500',
  ES_1: 'ES1!',
  NAS_100: 'NAS100',
  DAX: 'DAX',
  GER_30: 'GER30',
  INDEX_DEU_30: 'INDEX:DEU30',
  NG1: 'NG1!',
  FX_US_OIL: 'FX:USOIL',
  AUDUSD: 'AUDUSD',
  FX_XAU_USD: 'FX:XAUUSD',
  FX_IDC_XAU_USD: 'FX_IDC:XAUUSD',
  XAGUSD: 'XAGUSD',
  FX_XAGUSD: 'FX:XAGUSD',
  TVC_SILVER: 'TVC:SILVER',
  FX_IDC_XAGUSD: 'FX_IDC:XAGUSD',
  FX_IDC_EUR_CAD: 'FX_IDC:EURCAD',
  FX_IDC_AUD_CAD: 'FX_IDC:AUDCAD',
  FX_CAD_JPY: 'FX:CADJPY',
  FX_AUD_NZD: 'FX:AUDNZD',
  FX_GBP_AUD: 'FX:GBPAUD',
  FX_GBP_CHF: 'FX:GBPCHF',
  FX_EUR_NZD: 'FX:EURNZD',
  FX_IDC_AUD_CHF: 'FX_IDC:AUDCHF',
  FX_IDC_EUR_CNY: 'FX_IDC:EURCNY',
  FX_USD_CNH: 'FX:USDCNH',
  FX_USD_NOK: 'FX:USDNOK',
  FX_EUR_NOK: 'FX:EURNOK',
  FX_USD_SEK: 'FX:USDSEK',
  FX_IDC_EUR_SEK: 'FX_IDC:EURSEK',
  FX_USD_MXN: 'FX:USDMXN',
  FX_IDC_USD_SGD: 'FX_IDC:USDSGD',
  FX_IDC_USD_BRL: 'FX_IDC:USDBRL',
  FX_IDC_USD_RON: 'FX_IDC:USDRON',
  FX_USD_DKK: 'FX:USDDKK',
  FX_GBP_NZD: 'FX:GBPNZD',
  DOWI: 'DOWI',
  JPN_225: 'JPN225',
  INDEX_NKY: 'INDEX:NKY',
  FX_UK_100: 'FX:UK100',
  OANDA_UK_100_GBP: 'OANDA:UK100GBP',
  INDEX_FTSE: 'INDEX:FTSE',
  EUS_TX_50: 'EUSTX50',
  FRA_40: 'FRA40',
  INDEX_CAC: 'INDEX:CAC',
  FX_UK_OIL: 'FX:UKOIL',
  ICE_EUR_BRN1: 'ICEEUR:BRN1!',
  CSCO: 'CSCO',
  FX_JPM: 'FX:JPM',
  FX_GOOG: 'FX:GOOG',
  FX_IDC_USD_COP: 'FX_IDC:USDCOP',
  FOREXCOM_SPX_USD: 'FOREXCOM:SPXUSD',
  FOREXCOM_DJI: 'FOREXCOM:DJI',
  GLOBALPRIME_US2000: 'GLOBALPRIME:US2000',
  CAPITALCOM_NIFTY50: 'CAPITALCOM:NIFTY50',
  VANTAGE_INDIA50: 'VANTAGE:INDIA50',
  CME_LBS1: 'CME:LBS1!',
  GLOBALPRIME_DXZ2022: 'GLOBALPRIME:DXZ2022',
  CME_GE1: 'CME:GE1!'
}

export const FORBIDDEN_TV_SYMBOLS = [
  'XGY0',
  'INDEX:000001',
  'TUZ2015',
  'TYZ2015',
  'USZ2015',
  'FX:BUND',
  'EUREX:II1!',
  'EUREX:HR1!',
  'INDEX:BCL',
  'INDEX:BBR',
  'EUREX:GG1!',
  'TYZ2016'
]

export const FORBIDDEN_TV_SYMBOLS_LOWERCASED = FORBIDDEN_TV_SYMBOLS.map(
  symbol => symbol.toLowerCase()
)
